import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Shield, AlertTriangle, LogOut } from 'lucide-react';

function NoPermissions() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-yellow-100 mb-4">
          <Shield className="h-8 w-8 text-yellow-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-2">No Permissions Assigned</h2>
        
        <p className="text-gray-600 mb-6">
          Your account doesn't have any permissions assigned yet. Please contact your administrator to get the necessary access rights.
        </p>
        
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
            <div className="text-left">
              <h3 className="font-semibold text-yellow-800 mb-1">Account Status</h3>
              <p className="text-sm text-yellow-700">
                <strong>User:</strong> {user?.name || 'Unknown'}<br />
                <strong>Role:</strong> {user?.role === 3 ? 'Admin' : user?.role === 4 ? 'SuperAdmin' : 'Unknown'}<br />
                <strong>Email:</strong> {user?.email || 'Not provided'}
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-blue-800 mb-2">Next Steps</h3>
          <p className="text-sm text-blue-700">
            1. Contact your system administrator<br />
            2. Request the necessary permissions for your role<br />
            3. Once permissions are assigned, refresh this page
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => window.location.reload()}
            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
          >
            <Shield className="h-4 w-4 mr-2" />
            Refresh Permissions
          </button>
          
          <button
            onClick={handleLogout}
            className="flex-1 bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoPermissions;
